
import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

interface EmptyStateAction {
  label: string;
  to?: string;
  onClick?: () => void;
}

interface Props {
  icon?: string;
  title: string;
  description?: ReactNode;
  action?: EmptyStateAction;
  variant?: 'card' | 'inline';
}

export default function EmptyState({
  icon = 'inbox',
  title,
  description,
  action,
  variant = 'card',
}: Props) {
  const wrapperClass =
    variant === 'card'
      ? 'bg-white dark:bg-slate-900 border-2 border-blue-100 dark:border-blue-900/30 rounded-xl shadow-xl p-8'
      : 'rounded-lg border border-dashed border-slate-200 dark:border-slate-800 p-6';

  return (
    <div className={wrapperClass}>
      <div className="flex flex-col items-center text-center max-w-md mx-auto py-6">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-blue-50 dark:bg-blue-900/20 text-primary mb-5">
          <span className="material-symbols-outlined text-2xl">{icon}</span>
        </div>
        <h2 className="text-lg font-bold text-slate-900 dark:text-white leading-tight mb-2">
          {title}
        </h2>
        {description && (
          <p className="text-sm text-slate-500 dark:text-slate-400 leading-relaxed mb-6">
            {description}
          </p>
        )}
        {action && action.to && (
          <Link
            to={action.to}
            className="bg-primary hover:bg-blue-700 text-white px-5 py-2.5 rounded-lg text-sm font-bold shadow-lg shadow-primary/20 transition-all flex items-center gap-2"
          >
            {action.label}
            <span className="material-symbols-outlined text-sm">arrow_forward</span>
          </Link>
        )}
        {action && !action.to && action.onClick && (
          <button
            type="button"
            onClick={action.onClick}
            className="bg-primary hover:bg-blue-700 text-white px-5 py-2.5 rounded-lg text-sm font-bold shadow-lg shadow-primary/20 transition-all flex items-center gap-2"
          >
            {action.label}
            <span className="material-symbols-outlined text-sm">arrow_forward</span>
          </button>
        )}
      </div>
    </div>
  );
}
